import { IcmsOrigin } from '@/core/domain/invoice/invoiceNoteItems/invoiceNoteItemsParts/InvoiceNoteItems.types';
import { Select, SelectProps } from 'antd';
import { forwardRef } from 'react';

const data = [
  {
    value: IcmsOrigin.NATIONAL_EXCEPT_CODES_3458,
    label: '0 - Nacional, exceto as indicadas nos códigos 3, 4, 5 e 8',
  },
  {
    value: IcmsOrigin.FOREIGN_DIRECT_IMPORT_EXCEPT_CODE_6,
    label: '1 - Estrangeira - Importação direta, exceto a indicada no código 6',
  },
  {
    value: IcmsOrigin.FOREIGN_ACQUIRED_IN_DOMESTIC_MARKET_EXCEPT_CODE_7,
    label:
      '2 - Estrangeira - Adquirida no mercado interno, exceto a indicada no código 7',
  },
  {
    value: IcmsOrigin.NATIONAL_CONTENT_IMPORTATION_40_70,
    label:
      '3 - Nacional, mercadoria ou bem com Conteúdo de Importação superior a 40% e inferior a 70%',
  },
  {
    value: IcmsOrigin.NATIONAL_BASIC_PRODUCTION_PROCESS,
    label:
      '4 - Nacional, cuja produção tenha sido feita em conformidade com os processos produtivos básicos de que tratam as legislações citadas nos Ajustes',
  },
  {
    value: IcmsOrigin.NATIONAL_CONTENT_IMPORTATION_40,
    label:
      '5 - Nacional, mercadoria ou bem com Conteúdo de Importação inferior ou a 40%',
  },
  {
    value: IcmsOrigin.FOREIGN_DIRECT_IMPORT_NO_NATIONAL_SIMILAR_CAMEX,
    label:
      '6 - Estrangeira - Importação direta, sem similar nacional, constante em lista de CAMEX e gás natural',
  },
  {
    value:
      IcmsOrigin.FOREIGN_ACQUIRED_IN_DOMESTIC_MARKET_NO_NATIONAL_SIMILAR_CAMEX,
    label:
      '7 - Estrangeira - Adquirida no mercado interno, sem similar nacional, constante lista CAMEX e gás natural',
  },
  {
    value: IcmsOrigin.NATIONAL_CONTENT_IMPORTATION_70,
    label: '8 - Nacional, mercadoria',
  },
];

const TaxeIcmsOriginSelect = forwardRef<BaseSelectRef, SelectProps>(
  (props, ref) => {
    return (
      <Select
        {...props}
        showSearch
        optionFilterProp="label"
        ref={ref}
        options={data}
      />
    );
  },
);

export default TaxeIcmsOriginSelect;
